import { Button, Menu, Box } from '@mui/material';
import React from 'react';
import { useMenu } from '../../../../hooks/use-menu';
import { VyIcon } from '@vy/ui-design-system';
import { dynamicInvoicePageSelectors, getSelectorAttribute } from '@vy/app-selectors';

type AddRevisionedLineItemButtonProps = {
  children: React.ReactNode;
};

export const AddRevisionedLineItemButton: React.FC<AddRevisionedLineItemButtonProps> = ({ children }) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();

  return (
    <Box>
      <Button
       {...getSelectorAttribute(dynamicInvoicePageSelectors.revision.revisonAddItemButton)}
        variant="contained"
        color="secondary"
        size="medium"
        onClick={handleMenuOpen}
        endIcon={<VyIcon icon="ArrowDown" />}
      >
        Add Item
      </Button>

      <Menu
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              width: 136,
              borderRadius: 1,
              boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
              backgroundColor: '#FFF',
            },
          },
        }}
      >
        {children}
      </Menu>
    </Box>
  );
};
